import { __assign } from 'tslib';
import { InteractionMetrics } from './interactionMetrics.esm.js';
import { PerformanceMetrics } from './performanceMetrics.esm.js';
import { SystemEvent, SystemEventLevel } from './systemEvent.esm.js';
var ClientMetricsLogger = /** @class */function () {
  function ClientMetricsLogger(clientLogger) {
    this.clientLogger = clientLogger;
    if (!ClientMetricsLogger.pm || !ClientMetricsLogger.im) {
      this.initMetrics();
    }
  }
  ClientMetricsLogger.prototype.initLogger = function (metadata) {
    var client = metadata.client,
      lob = metadata.lob,
      locale = metadata.locale,
      siteId = metadata.siteId,
      personalize = metadata.personalize,
      inputId = metadata.inputId,
      getDevice = metadata.getDevice,
      variants = metadata.variants;
    ClientMetricsLogger.metadata = {
      client: client,
      lob: lob,
      locale: locale,
      siteId: siteId,
      personalize: personalize,
      inputId: inputId,
      getDevice: getDevice,
      variants: variants
    };
  };
  ClientMetricsLogger.prototype.logTypeaheadOpen = function (prefill) {
    ClientMetricsLogger.im.logTypeaheadOpen(prefill);
  };
  ClientMetricsLogger.prototype.logTypeaheadRequest = function (query) {
    ClientMetricsLogger.im.logTypeaheadRequest(query);
    ClientMetricsLogger.pm.logTypeaheadRequest(query);
  };
  ClientMetricsLogger.prototype.logResponse = function (response) {
    ClientMetricsLogger.pm.logResponse(response);
  };
  ClientMetricsLogger.prototype.logTypeaheadResponse = function (response) {
    ClientMetricsLogger.pm.logTypeaheadResponse(response);
  };
  ClientMetricsLogger.prototype.logSuggestionShown = function (response) {
    ClientMetricsLogger.pm.logSuggestionShown(response.q);
    ClientMetricsLogger.im.logSuggestionShown(response);
  };
  ClientMetricsLogger.prototype.logSuggestionSelected = function (selected, taEventMessage) {
    ClientMetricsLogger.im.logTypeaheadSelection(selected);
    ClientMetricsLogger.im.logTypeaheadEventMessage(taEventMessage);
  };
  ClientMetricsLogger.prototype.logError = function (statusCode) {
    ClientMetricsLogger.pm.logError(statusCode);
  };
  ClientMetricsLogger.prototype.logTypeaheadClientMetrics = function () {
    if (this.clientLogger && typeof this.clientLogger.getLoggerWithIdentifier === 'function') {
      var logger = this.clientLogger.getLoggerWithIdentifier('uitk-react-typeahead');
      if (logger && typeof logger.logEvent === 'function') {
        logger.logEvent(new SystemEvent(SystemEventLevel.INFO, 'TypeaheadInteraction'), __assign(__assign({}, ClientMetricsLogger.im.getMetrics(ClientMetricsLogger.metadata)), ClientMetricsLogger.pm.getMetrics()));
      }
    }
    this.initMetrics();
  };
  ClientMetricsLogger.prototype.initMetrics = function () {
    ClientMetricsLogger.im = new InteractionMetrics(); // Clear interaction logs
    ClientMetricsLogger.pm = new PerformanceMetrics(); // Clear performance logs
  };
  return ClientMetricsLogger;
}();
export { ClientMetricsLogger };